import awsExports from '@/aws-exports'

/**
 * Excel 説明を出さない画面パス（完全一致またはプレフィックス）
 * エクスポート／インポート一覧・ダッシュボード
 */
export const NO_EXCEL_MANUAL_PATHS = ['/h', '/h/export', '/h/import']

/**
 * マニュアル配信のベース URL。
 * 本番系は aws-exports.manualsBaseUrl（CloudFront）。
 * 未設定時はローカル用に /manuals（public/manuals）へフォールバック。
 */
export function getManualsBaseUrl(): string {
  const fromAws = (awsExports as { manualsBaseUrl?: string }).manualsBaseUrl
  if (fromAws && fromAws.trim() !== '' && !fromAws.includes('%%')) {
    return fromAws.replace(/\/$/, '')
  }
  return '/manuals'
}

/** ルートパスからマニュアル相対パス（先頭スラッシュなし）を作る */
export function routePathToManualKey(routePath: string): string {
  const normalized = (routePath || '').replace(/\/+$/, '') || '/'
  return normalized.replace(/^\//, '')
}

export function hasExcelManual(routePath: string): boolean {
  const normalized = (routePath || '').replace(/\/+$/, '') || '/'
  return !NO_EXCEL_MANUAL_PATHS.includes(normalized)
}
